@if (user$ | async; as user) {
  <div>
    <p>Name: {{user.name}}</p>
    <p>Audit Id: {{user.app_metadata.audit_id}}</p>
    <p>Groups: {{user.app_metadata.instances}}</p>
    <p>Email: {{user.email}}</p>
    <p>Phone: {{ user.phone_number}}</p>
    <p>Roles: {{user.app_metadata.roles}}</p>
    <p>Last login: {{user.last_login | date: 'long'}}</p>
  </div>
}
